import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { filter } from 'rxjs/operators';

import { RequestCacheEntry } from './request-cache-entry';
import { AuthService } from './auth.service';
import { RequestCache } from './request-cache';


const maxAge = 600000; // maximum cache age (ms)

@Injectable()
export class RequestCacheService implements RequestCache {
  cache = new Map<string, RequestCacheEntry>();

  constructor(authService: AuthService) {
    authService.isLogin$.pipe(filter((isLogin) => !isLogin)).subscribe(() => this.cache.clear());
  }

  get(req: HttpRequest<any>): HttpResponse<any> | undefined {
    const url = req.urlWithParams;
    const cached = this.cache.get(url);

    if (!cached) {
      return undefined;
    }

    const isExpired = cached.lastRead < Date.now() - maxAge;
    return isExpired ? undefined : cached.response;
  }

  put(request: HttpRequest<any>, response: HttpResponse<any>): void {
    const url = request.urlWithParams;

    const entry = { url, response, lastRead: Date.now() };
    this.cache.set(url, entry);

    const expired = Date.now() - maxAge;
    this.cache.forEach((cacheEntry) => {
      if (cacheEntry.lastRead < expired) {
        this.cache.delete(cacheEntry.url);
      }
    });
  }
}
